
import { ILoadCarrierService } from '@/modules/loadCarriers/service/ILoadCarrierService';
import { LoadCarrierServiceExceptionDecorator } from '@/modules/loadCarriers/service/LoadCarrierServiceExceptionDecorator';
import { LoadCarrierServiceLogDecorator } from '@/modules/loadCarriers/service/LoadCarrierServiceLogDecorator';
import { LoadCarrierServiceImpl } from '@/modules/loadCarriers/service/LoadCarrierServiceImpl';
import { useLoadCarrierStore } from '@/modules/loadCarriers/store/useLoadCarrierStore';

export class LoadCarrierServiceFactory {
  private static instance: LoadCarrierServiceFactory | null = null;
  private loadCarrierStore: typeof useLoadCarrierStore;

  public static initialize(
    loadCarrierStore: typeof useLoadCarrierStore,
  ) {
    LoadCarrierServiceFactory.instance = new LoadCarrierServiceFactory(
      loadCarrierStore,
    );
  }

  public static getInstance() {
    if (LoadCarrierServiceFactory.instance === null) {
      throw new Error(
        'LoadCarrierServiceFactory not yet initialized. Call LoadCarrierServiceFactory.initialize() first.',
      );
    }
    return LoadCarrierServiceFactory.instance;
  }

  private constructor(
    loadCarrierStore: typeof useLoadCarrierStore,
  ) {
    this.loadCarrierStore = loadCarrierStore;
  }

  public createLoadCarrierService(): ILoadCarrierService {
    let result: ILoadCarrierService = this.makeLoadCarrierService();

    result = new LoadCarrierServiceExceptionDecorator(result);
    result = new LoadCarrierServiceLogDecorator(result);

    return result;
  }

  private makeLoadCarrierService(): ILoadCarrierService {
    return new LoadCarrierServiceImpl(this.loadCarrierStore);
  }
}
